// extracted by mini-css-extract-plugin
export default {"component":"SeoLink__component--ig-xLNOJ"};